import { __assign as s } from "./atoms-v21282.js";
var l = function(r, n) {
  return function(t) {
    return Math.max(Math.min(t, n), r);
  };
}, g = function(r) {
  return r % 1 ? Number(r.toFixed(5)) : r;
}, b = /^(#[0-9a-f]{3}|#(?:[0-9a-f]{2}){2,4}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2,3}\s*\/*\s*[\d\.]+%?\))$/i, f = {
  test: function(r) {
    return typeof r == "number";
  },
  parse: parseFloat,
  transform: function(r) {
    return r;
  }
}, c = s(s({}, f), { transform: l(0, 1) });
s(s({}, f), { default: 1 });
var d = function(r) {
  return {
    test: function(n) {
      return typeof n == "string" && n.endsWith(r) && n.split(" ").length === 1;
    },
    parse: parseFloat,
    transform: function(n) {
      return "" + n + r;
    }
  };
}, o = d("%");
s(s({}, o), { parse: function(r) {
  return o.parse(r) / 100;
}, transform: function(r) {
  return o.transform(r * 100);
} });
var m = function(r) {
  return r.substring(r.indexOf("(") + 1, r.lastIndexOf(")"));
}, h = l(0, 255), v = function(r) {
  return r.red !== void 0;
};
function y(r) {
  return m(r).replace(/(,|\/)/g, " ").split(/ \s*/);
}
var x = function(r) {
  return function(n) {
    if (typeof n != "string")
      return n;
    for (var t = {}, e = y(n), a = 0; a < 4; a++)
      t[r[a]] = e[a] !== void 0 ? parseFloat(e[a]) : 1;
    return t;
  };
}, F = function(r) {
  var n = r.red, t = r.green, e = r.blue, a = r.alpha, u = a === void 0 ? 1 : a;
  return "rgba(" + n + ", " + t + ", " + e + ", " + u + ")";
}, i = s(s({}, f), { transform: function(r) {
  return Math.round(h(r));
} });
function p(r, n) {
  return r.startsWith(n) && b.test(r);
}
var I = {
  test: function(r) {
    return typeof r == "string" ? p(r, "rgb") : v(r);
  },
  parse: x(["red", "green", "blue", "alpha"]),
  transform: function(r) {
    var n = r.red, t = r.green, e = r.blue, a = r.alpha, u = a === void 0 ? 1 : a;
    return F({
      red: i.transform(n),
      green: i.transform(t),
      blue: i.transform(e),
      alpha: g(c.transform(u))
    });
  }
};
s(s({}, I), { test: function(r) {
  return typeof r == "string" && p(r, "#");
}, parse: function(r) {
  var n = "", t = "", e = "";
  return r.length > 4 ? (n = r.substr(1, 2), t = r.substr(3, 2), e = r.substr(5, 2)) : (n = r.substr(1, 1), t = r.substr(2, 1), e = r.substr(3, 1), n += n, t += t, e += e), {
    red: parseInt(n, 16),
    green: parseInt(t, 16),
    blue: parseInt(e, 16),
    alpha: 1
  };
} });
export {
  c as alpha,
  f as number,
  o as percent,
  i as rgbUnit,
  I as rgba
};
